"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pill = exports.IconWrapper = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _mixins = require("../../styles/mixins");
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("../../utils/styled-is"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBPill = require("../HBPill/HBPill.types");
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _templateObject, _templateObject2;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/* Pill sizes */
var pillSizes = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _HBPill.PillSize.Small, {
  fontSize: '10px',
  lineHeight: '12px',
  borderRadius: '20px',
  height: '15px',
  padding: "2px 6px 1px"
}), _HBPill.PillSize.Medium, {
  fontSize: '14px',
  borderRadius: '20px',
  height: '30px',
  padding: "7px ".concat(_spacing["default"][12])
});

/* Pill themes */
var pillThemes = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _HBPill.PillType.Draft, {
  background: _colors["default"].neutral200,
  color: _colors["default"].neutral700
}), _HBPill.PillType.Success, {
  background: _colors["default"].green50,
  color: _colors["default"].white
}), _HBPill.PillType.Sent, {
  background: _colors["default"].blue20_20,
  color: _colors["default"].blue20
}), _HBPill.PillType.Template, {
  background: _colors["default"].neutral100,
  color: _colors["default"].neutral700,
  border: "1px solid ".concat(_colors["default"].neutral200)
}), _HBPill.PillType.InProgress, {
  background: _colors["default"].blue20,
  color: _colors["default"].white
}), _HBPill.PillType.Warning, {
  background: _colors["default"].orange50,
  color: _colors["default"].white
}), _HBPill.PillType.Expired, {
  background: _colors["default"].red50_15,
  color: _colors["default"].red60
}), _HBPill.PillType.Default, {
  background: _colors["default"].neutral200,
  color: _colors["default"].neutral900
});
var Pill = exports.Pill = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBPillstyles__Pill",
  componentId: "sc-10j2fom-0"
})(["", " ", ";", ";", ";margin:", ";line-height:1;border-radius:20px;min-width:max-content;width:max-content;", " ", ""], function (props) {
  return pillThemes[props.theme];
}, _mixins.proximaNova, _mixins.flexCenterAll, function (props) {
  return pillSizes[props.size];
}, function (props) {
  return props.$margin;
}, (0, _styledIs.isNot)('$isLowerCase')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        text-transform: uppercase;\n        font-weight: 600;\n    "]))), (0, _styledIs["default"])('$isLoading')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        padding: 0;\n        span {\n            height: 100%;\n            width: 100%;\n        }\n    "]))));
var IconWrapper = exports.IconWrapper = _styledComponents["default"].span.withConfig({
  displayName: "HBPillstyles__IconWrapper",
  componentId: "sc-10j2fom-1"
})(["", " padding-right:4px;padding-bottom:0;"], function (props) {
  return (0, _mixins.setIconFillColor)(pillThemes[props.theme].color);
});
//# sourceMappingURL=HBPill.styles.js.map